export const version = "1.0.2-daily-20251226-0";
export const channel = "daily";
export const gitcommit = "e8cd2fd84";
